import {Panes, TextField} from '@management-ui/core';
import {InputAdornment} from '@mui/material';
import React from 'react';

const Fields = ({target = {}, prefix = '', children}) => (
  <Panes
    entity={target}
    prefix={prefix}
    panes={[
      {
        title: 'Tiers',
        fields: [
          <TextField
            name="break_even"
            prefix={prefix}
            label="Break Even"
            rules={{required: 'Please enter an amount'}}
            fieldProps={{
              InputProps: {
                startAdornment: <InputAdornment position="start">£</InputAdornment>
              }
            }}
          />,
          <TextField
            name="good"
            prefix={prefix}
            label="Good"
            rules={{required: 'Please enter an amount'}}
            fieldProps={{
              InputProps: {
                startAdornment: <InputAdornment position="start">£</InputAdornment>
              }
            }}
          />,
          <TextField
            name="over_achieve"
            prefix={prefix}
            label="Over Achieve"
            rules={{required: 'Please enter an amount'}}
            fieldProps={{
              InputProps: {
                startAdornment: <InputAdornment position="start">£</InputAdornment>
              }
            }}
          />,
        ]
      }
    ]}
    title={null}
  >{children}</Panes>
);

export default Fields
